import * as actionTypes from './actionTypes';

export const getHistoricalQoeMetrics = (payload) => {
  return {
    type: actionTypes.GET_HISTORICAL_QOE_METRICS,
    payload
  };
};

export const getQoeScores = () => {
  return {
    type: actionTypes.GET_QOE_SCORES
  };
};

export const getQoeScoresSuccess = (payload) => ({
  type: actionTypes.GET_QOE_SCORES_SUCCESS,
  payload
});

export const getQoeScoresFailed = () => ({
  type: actionTypes.GET_QOE_SCORES_FAILED
});

export const getQoeSuccess = (payload) => ({
  type: actionTypes.GET_QOE_SUCCESS,
  payload
});

export const getQoeFailed = () => ({
  type: actionTypes.GET_QOE_FAILED
});

export const getQoeFailedReset = () => ({
  type: actionTypes.GET_QOE_FAILED_RESET
});

export const logQoeResults = (browser, overallStatus, qoeData, routerMac) => ({
  type: actionTypes.LOG_QOE_RESULTS,
  routerMac,
  browser,
  overallStatus,
  qoeData,
})